export default function showHeaderFooter({ locale, pathname }) {
  switch (locale) {
    case 'en-US':
    case 'us':
      return (!pathname.includes('print') && !pathname.includes('terms')) && !pathname.includes('/stand-alone-supps/');
    default:
      return true;
  }
}
